<div class="logo-holder">
  <img [src]="logoImg" />
</div>
<h3 class="title-holder">
  {{ 'PRIVACY.TITLE' | translate }}
</h3>
<div class="paragraph-holder">
  <p>{{ 'PRIVACY.PRIVACY_STATEMENT_ONE' | translate }}</p>
  <p>{{ 'PRIVACY.PRIVACY_STATEMENT_TWO' | translate }}</p>
  <p>{{ 'PRIVACY.PRIVACY_STATEMENT_THREE' | translate }}</p>
</div>
<div class="link-holder">
  <p *ngIf="!isMyAccountPage">
    {{ 'PRIVACY.PLEASE_READ_PRIVACY' | translate }}
  </p>
  <span (click)="privacyStatementClick()">{{
    'PRIVACY.PRIVACY_STATEMENT_LINK' | translate
  }}</span>
</div>
